import { defineFeatures } from "../define-provider-capability";

/**
 * The `customerio` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const customerioMobileFeatures = defineFeatures({
  // Mobile-side Customer.io SDK init keys (different env names from the
  // server-side `client` feature; stored in mobile/<env-instance> Doppler).
  mobile: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: { mode: "managed" },
    },
    env: [
      {
        name: "EXPO_PUBLIC_CUSTOMERIO_API_KEY",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "environment" },
      },
      {
        name: "EXPO_PUBLIC_CUSTOMERIO_SITE_ID",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "environment" },
      },
    ],
  },
});
